import React from 'react';

interface DeprecatedPlaceholderProps {
  message: string;
}

const DeprecatedPlaceholder: React.FC<DeprecatedPlaceholderProps> = ({ message = "This component is deprecated." }) => {
  return (
    <div style={{
      padding: '20px',
      border: '2px solid #ffcc00',
      backgroundColor: '#fffacd',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    }}>
      <span style={{ fontSize: '20px' }}>⚠️</span>
      <p style={{ margin: 0, color: '#333' }}>
        {message}
      </p>
    </div>
  );
};

export default DeprecatedPlaceholder;
